module.exports = __webpack_public_path__ + "img/Sue.eb6be279.svg";